import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { McpAuthPage } from 'features/mcpauth'
import { z } from 'zod/v4'

const mcpAuthSearchSchema = z.object({
  external_auth_id: z.string().trim().min(1, 'external_auth_id is required'),
})

export type McpAuthSearch = z.infer<typeof mcpAuthSearchSchema>

export const Route = createFileRoute('/_authenticated/mcp-auth')({
  component: McpAuthPage,
  validateSearch: mcpAuthSearchSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('MCP Auth'),
      },
    ],
  }),
})
